module.exports = __webpack_public_path__ + "img/profileNotSigned.909637f8.svg";